import { render } from "./Main.vue?vue&type=template&id=3d7d0638"
const script = {}
script.render = render

export default script